import React from 'react';
import styles from './AppButton.module.scss';

export default function AppButton(props) {
    return (
        <div className={`${styles.btn} btn-block-md btn ${props.function ? "btn-dark" : "btn-primary"} ${props.className}`} 
            onClick={()=> {if(!props.ajaxInProgress) props.onClick()}}>
            {props.ajaxInProgress ? <div className="lds-dual-ring"></div> :
            <div className="icon">
                <i className={`${props.iconName} ${(props.highlight ? "highlight" : "")}`} aria-hidden="true"></i>
            </div>}
            <div className="text">
                <div>{props.header}</div>
                <div className="action">{props.actionText}</div>
                <div>{props.footer}</div>
            </div>
        </div>
    );    
}
